import { ErrorIcon, TelegramIcon } from "../../assets/icons";
import { Button } from "../button/button";
import { openExternalLink } from "../../utils/openExternalLink";
import { Text } from "../text/text";

import styles from "./error.module.css";

export const ErrorBoundary = () => {
    const supportContact = process.env.REACT_APP_SUPER_ADMIN_NAME || "";
    const supportUrl = /^https?:\/\//i.test(supportContact)
        ? supportContact
        : `https://t.me/${supportContact.replace(/^@/, "")}`;

    return (
        <div className={styles.error}>
            <ErrorIcon className={styles.error_icon} />
            <Text as="div" variant="h1" className={styles.error_title} align="center">Упс! Что-то пошло не так...</Text>
            <Text as="div" variant="h2" weight={400} className={styles.error_subtitle} align="center">
                Попробуйте перезагрузить страницу или обратитесь в поддержку, если проблема сохраняется.
            </Text>

            <Button
                text="Поддержка"
                icon={<TelegramIcon />}
                type="info"
                onClick={() => openExternalLink(supportUrl)}
            />
        </div>
    );
}